import { useMemo } from "react";
import cn from "classnames";
import { railErrorMessageMap } from "entities/shared/railCard.types";
import { RailSearchCardModel } from "entities/RailSearchCard";
import { Nullable } from "shared/lib/typeCheck.lib";
import { useTranslation } from "shared/localization/localization";
import styles from "./EventList.module.scss";

import { useOpenedCardEvents } from "../../model/hooks/useOpenedCardEvents";
import { Event } from "../Event";

type EventListProps = {
  className?: string;
  data: Nullable<RailSearchCardModel>;
};

export const EventList: RFC<EventListProps> = ({ data, className }) => {
  const { t } = useTranslation();
  const { hasEventEntries, eventEntries } = useOpenedCardEvents(data);

  const errorMessage = useMemo(() => {
    const defaultErrorText = "Route is not available at the moment";
    if (!data) {
      return defaultErrorText;
    }
    return t(railErrorMessageMap[data.responseStatus] ?? defaultErrorText);
  }, [data?.rawData]);

  return (
    <div className={cn(styles["event-list"], !hasEventEntries && styles["not-available"], className)}>
      {hasEventEntries ? (
        eventEntries.map((eventEntry, eventEntryIndex) => {
          const isLastEvent = eventEntries.length - 1 === eventEntryIndex;

          return <Event key={eventEntryIndex} eventEntry={eventEntry} isLastEvent={isLastEvent} />;
        })
      ) : (
        <>
          <div className={styles["not-available-bold"]}>{errorMessage}.</div>
          <div className={styles["not-available-normal"]}>{t("Please, try again later")}.</div>
        </>
      )}
    </div>
  );
};
